<template>
  <b-dropdown position="is-bottom-left">
    <button slot="trigger" class="button">
      <b-icon icon="link"></b-icon>
    </button>

    <div class="dropdown-item" style="width: 250px;">
      <b-field v-for="(link, index) in links" :key="index" :label="link.label">
        <clipboard-input :size="size" :value="link.url"></clipboard-input>
      </b-field>
    </div>
  </b-dropdown>
</template>

<script>
export default {
  props: ["links", "size"]
};
</script>
